"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_9b8b16d8{position:relative;font-size:12px;background:transparent;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.focusZone_9b8b16d8{display:inline-block;vertical-align:top;min-width:100%;min-height:1px}.rootIsHorizontalConstrained_9b8b16d8{overflow-x:auto;overflow-y:visible;-webkit-overflow-scrolling:touch}.root_9b8b16d8 .ms-List-cell{min-height:38px;word-break:break-word}.rootCompact_9b8b16d8 .ms-List-cell{min-height:32px}\n" }]);
exports.root = "root_9b8b16d8";
exports.focusZone = "focusZone_9b8b16d8";
exports.rootIsHorizontalConstrained = "rootIsHorizontalConstrained_9b8b16d8";
exports.rootCompact = "rootCompact_9b8b16d8";
//# sourceMappingURL=DetailsList.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/DetailsList/DetailsList.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/DetailsList/DetailsList.scss.js
// module chunks = 1